<template>
  <section class="menu-height">
    <b-menu>
      <b-menu-list>
        <b-menu-item icon-pack="fas" icon="fas fa-home" label="Home" tag="router-link" to="/home"></b-menu-item>
        <b-menu-item icon-pack="fas" icon="fas fa-box-open" label="Product"  tag="router-link" to="/product" >
        </b-menu-item>
        <b-menu-item icon-pack="fas" icon="fas fa-sitemap" label="Family" tag="router-link" to="/family">
        </b-menu-item>
        <b-menu-item icon-pack="fas" icon="fas fa-file-invoice-dollar" label="Estimate" tag="router-link" to="/estimate-gst">
        </b-menu-item>
      </b-menu-list>
    </b-menu>
  </section>
</template>

<script>
export default {
name:'Menu',
data() {
    return {
    };
  },

}
</script>

<style>
.menu-height {
  height: 100vh;
}
</style>